import React from "react";
import { ReactComponent as CloseIcon } from "../../build/images/close-circle.svg";
import { ReactComponent as AttachIcon } from "../../build/images/attachment.svg";

const AttachFiles = ({attach,removeFile,index,bind}) => {
  return (
      <div className="attach__files-container">
            <div className="attach__files-container__title">
                <AttachIcon />
                {attach.label}
            </div>
            <div className="attach__files-container__delete" onClick={event => removeFile(event,index,bind)}>
                <CloseIcon />
            </div>
      </div>
  );
};

export default AttachFiles;
